

(function () {
  const DISABLE_TIME = 1000; // 1s

  function disableCheckoutBtn() {
    const btn = document.getElementById('CartDrawer-Checkout');
    if (!btn) return;

    // disable
    btn.disabled = true;
    btn.style.pointerEvents = 'none';
    btn.classList.add('bss-disabled');

    setTimeout(() => {
      btn.disabled = false;
      btn.style.pointerEvents = 'auto';
      btn.classList.remove('bss-disabled');
    }, DISABLE_TIME);
  }

  // Dawn open drawer = DOM chage
  const observer = new MutationObserver(() => {
    const btn = document.getElementById('CartDrawer-Checkout');
    if (!btn) return;

    const isVisible =
      btn.offsetParent !== null ||
      btn.style.display !== 'none';

    if (isVisible && !btn.dataset.bssHandled) {
      btn.dataset.bssHandled = 'true';
      disableCheckoutBtn();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
